var _path, _path2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHowItWorksLineTwo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 2 117"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_3085_71887)",
  d: "M1 0v117"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint1_linear_3085_71887)",
  d: "M1 0v117",
  className: "active-line"
})), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3085_71887",
  x1: 1.5,
  x2: 1.5,
  y1: 0,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0EB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0E0EB"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3085_71887",
  x1: "0%",
  x2: "0%",
  y1: 0,
  y2: "100%",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#2f64ed",
    stopOpacity: 1
  }
}))));
export { SvgHowItWorksLineTwo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMiAxMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDBWMTE3IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8zMDg1XzcxODg3KSIvPgo8cGF0aCBjbGFzcz0iYWN0aXZlLWxpbmUiIGQ9Ik0xIDBWMTE3IiBzdHJva2U9InVybCgjcGFpbnQxX2xpbmVhcl8zMDg1XzcxODg3KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzMwODVfNzE4ODciIHgxPSIxLjUiIHkxPSIwIiB4Mj0iMS41IiB5Mj0iMTE3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFMEUwRUIiIHN0b3Atb3BhY2l0eT0iMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFMEUwRUIiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzMwODVfNzE4ODciIHgxPSIwJSIgeTE9IjAiIHgyPSIwJSIgeTI9IjEwMCUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICA8c3RvcCBvZmZzZXQ9IjcwJSIgc3R5bGU9InN0b3AtY29sb3I6IzJGNjRFRDtzdG9wLW9wYWNpdHk6MCIgLz4KICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiMyRjY0RUQ7c3RvcC1vcGFjaXR5OjEiIC8+CiAgPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";